module.exports = __webpack_public_path__ + "static/ezgif.com-gif-maker-8efa12a3a483fb9788701515e0e3c467.gif";